import moment from 'moment';
import * as API from '@/services/API';
import _ from 'underscore';
import LogRocket from 'logrocket';

//const key = require("@/assets/private.pem");
//console.log(key)
export default {
    state: {
        loggedIn:
            !!localStorage.getItem('token') ||
            moment().isAfter(localStorage.removeItem('expiry_time')),
        expiry_time: localStorage.removeItem('expiry_time'),
        userProfile: {
            roles: [],
            school: {},
            groups: [],
            image: {},
        },
        userExtraData: {},
        showLoginForm: false,
        projectsNumber: 0,
        objectsNumber: 0,
        usersNumber: 0,
    },
    mutations: {
        LOG_OUT(state) {
            state.loggedIn = false;
            state.expiry_time = null;
            state.projectsNumber = 0;
            state.objectsNumber = 0;
            state.usersNumber = 0;
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('expiry_time');
            localStorage.removeItem('vicensUser');
        },
        LOG_IN(state, payload) {
            if (payload.expires_in) {
                const expiry_time = moment()
                    .add(payload.expires_in, 's')
                    .toISOString();
                state.expiry_time = expiry_time;
                localStorage.setItem('expiry_time', expiry_time);
            }
            localStorage.setItem('token', payload.token);
            localStorage.setItem('refresh_token', payload.refresh_token);
            state.loggedIn = true;
            state.showLoginForm = false;
        },
        LOG_IN_LOCAL(state, payload) {
            localStorage.setItem('token', payload.token);
            localStorage.setItem('refresh_token', payload.refresh_token);
            state.loggedIn = true;
            state.showLoginForm = false;
        },
        SET_USER(state, userData) {
            state.userProfile = userData;
            state.projectsNumber = userData.data.projects;
            state.objectsNumber = userData.data.objects;
            state.usersNumber = userData.data.users;
            state.projectsPerTypeNumber = userData.data.projectsPerType;
            // LogRocket.identify(userData.email, userData); //change firts parameter to _id
        },
        SET_GROUPS(state, groups) {
            state.groups = groups;
        },
        REQUEST_LOGIN_FORM(state, isAnonymous) {
            if (!state.loggedIn || isAnonymous) {
                state.showLoginForm = true;
            }
        },
        CLOSE_LOGIN_FORM(state) {
            state.showLoginForm = false;
        },
        INCREMENT_PROJECTS_NUMBER(state) {
            state.projectsNumber++;
        },
        INCREMENT_OBJECTS_NUMBER(state) {
            state.objectsNumber++;
        },
        INCREMENT_USERS_NUMBER(state) {
            state.usersNumber++;
        },
        DECREMENT_PROJECTS_NUMBER(state) {
            state.projectsNumber--;
        },
        DECREMENT_OBJECTS_NUMBER(state) {
            state.objectsNumber--;
        },
        DECREMENT_USERS_NUMBER(state) {
            state.usersNumber--;
        },
        INCREMENT_PROJECTS_PER_TYPE_NUMBER(state, type) {
            state.projectsPerTypeNumber[type.format]++;
        },
        DECREMENT_PROJECTS_PER_TYPE_NUMBER(state, type) {
            state.projectsPerTypeNumber[type.format]--;
        },

    },
    actions: {
        /*
    context.state will expose the local state, and root state will be exposed as context.rootState
    */
        logout({ commit }) {
            commit('LOG_OUT');
        },
        async refreshToken({ commit }, payload) {
            commit('LOG_IN', payload);
        },

        async fetchProfile({ commit, dispatch, getters }) {
            const profileResponse = await API.fetchProfile().catch((e) => {
                dispatch('logout');
            });
            commit('SET_USER', profileResponse.data);
            //getters.canManageGroups && (await dispatch('fetchGroups'));
        },
        async updateProfile({ state, dispatch }, payload) {
            await API.updateItem('profile', state.userProfile._id, payload);
            dispatch('fetchProfile');
            // commit('SET_USER', profileResponse.data[0])
        },

        async fetchGroups({ commit }) {
            const response = await API.fetchItems('group')
                .then(() => {
                    commit('SET_GROUPS', response.data);
                })
                .catch(() => {
                    console.error('Failed to fetch groups');
                });
        },

        /*async login({ state, commit, dispatch }, payload) {
            if (state.isLoggedIn) {
                commit('LOG_OUT');
            }
            const response = await API.login(payload);
            if (response.data) {
                commit('LOG_IN', response.data);
                await dispatch('fetchProfile');
            } else {
                commit('LOG_OUT');
            }
        },*/

        async localLogin({ commit, dispatch }, payload) {
            const response = await API.localLogin(payload).catch((e) => { throw e; });;
            if (response.data) {
                // console.log("in login",)
                commit('LOG_IN', response.data);
                await dispatch('fetchProfile');
            } else {
                // console.log("in logout")
                commit('LOG_OUT');
            }
            /*const response = await API.localLogin(payload)
                .then((res) => {
                    //console.log(res)
                    if (res && res.status == '200') {
                        commit('LOG_IN', res.data);
                        await dispatch('fetchProfile');
                    }
                })
                .catch((e) => {
                    //console.log(e)
                    throw e;

                });*/
            /*const response = await API.localLogin(payload).catch(() => { });

            if (response && response.data) {
                console.log("api response", response)
                if (!response.data.error) {
                    commit('LOG_IN', response.data);
                    dispatch('fetchProfile');
                } else {
                    console.log(response.data)
                    throw response.data.error;
                }
            }*/
        },
        async validateToken({ state, commit, dispatch }, { idToken }) {
            const response = await API.validateToken({ idToken });
            if (response.data) {
                commit('LOG_IN', response.data);
                await dispatch('fetchProfile');
            } else {
                commit('LOG_OUT');
            }
        },
        async login({ state, commit, dispatch }, payload) {
            if (state.isLoggedIn) {
                commit('LOG_OUT');
            }
            const response = await API.login(payload);
            if (response.data) {
                commit('LOG_IN', response.data);
                await dispatch('fetchProfile');
            } else {
                commit('LOG_OUT');
            }
        },
        async loginFromCode({ state, commit, dispatch }, payload) {
            if (state.isLoggedIn) {
                commit('LOG_OUT');
            }
            commit('LOG_IN', payload);
            await dispatch('fetchProfile');

        },
        requestLoginForm({ commit, getters }) {
            commit('REQUEST_LOGIN_FORM', getters.isAnonymous);
        },
        closeLoginForm({ commit }) {
            commit('CLOSE_LOGIN_FORM');
        },
        async anonymousLogin({ commit, dispatch }, alias) {
            let jwt = require('jsonwebtoken');
            const username = parseInt(Math.ceil(Math.random() * Date.now()).toPrecision(9).toString().replace(".", ""));
            const email = username + "@no.mail";
            let token = jwt.sign({ username, email, alias }, process.env.VUE_APP_JWT_KEY, { 'issuer': "LABYLOK" });
            const response = await API.login({ 'id_token': token });
            if (response.data) {
                commit('LOG_IN', response.data);
                await dispatch('fetchProfile');
            } else {
                commit('LOG_OUT');
            }
        }
    },
    getters: {
        /*(state, getters, rootState)*/
        user: (state) => state.userProfile,
        userPlan: (state) => state.userProfile.plan,
        userRoles: (state) => state.userProfile.roles,
        canManageGroups: (state, getters) => {
            return _.some(getters.userRoles, function (value) {
                return _.contains(['teacher'], value);
            });
        },
        canManageSchool: (state, getters) => {
            return _.some(getters.userRoles, function (value) {
                return _.contains(['administrator', 'coordinator'], value);
            });
        },
        canCreateSessions: (state, getters, rootState) => {
            const gameTypes = ['trivial', 'treasurehunt'];
            return _.includes(gameTypes, rootState.project.type);
        },
        personalData: (state) => state.userProfile,
        isAdmin: (state, getters) =>
            _.contains(getters.userRoles, 'administrator'),
        school: (state) => state.userProfile.school || {},
        hasSchool: (state) => {            //!!state.userProfile.school,
            return state.userProfile.school ? Object.keys(state.userProfile.school).length > 0 : false
        },
        groups: (state, getters, rootState) => {
            return state.groups || [];
        },
        isLoggedIn: (state) => state.loggedIn,
        isStudent: (state, getters, rootState) => {
            return _.contains(getters.userRoles, 'student');
        },
        isTeacher: (state, getters, rootState) => {
            return (
                _.contains(getters.userRoles, 'teacher') &&
                !!state.userProfile.school
            );
        },
        isAnonymous: (state, getters, rootState) => {
            return _.contains(getters.userRoles, 'anonymous');
        },
        hasMinimumAge: (state) => state.userProfile.hasMinimumAge,
        TOSAccepted: (state) => state.userProfile.TOSAccepted,
        activePlan: (state, getters, rootState) => {
            if (state.userProfile.school && state.userProfile.school.configuration) {
                return state.userProfile.school
            } else {
                return state.userProfile.plan
            }
        },
        projectsNumber: (state) => state.projectsNumber,
        objectsNumber: (state) => state.objectsNumber,
        usersNumber: (state) => state.usersNumber,
        projectsPerTypeNumber: (state) => state.projectsPerTypeNumber
    },
};
